import { CurrencyCode } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { Money } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { InvoiceSummary } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { InvoiceSummary2 } from '@lsq-frontend/remote-services/financing-graphql';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function mapInvoicesToTotal(
    invoices$: Observable<(InvoiceSummary | InvoiceSummary2)[]>,
    moneyKey: keyof InvoiceSummary2
): Observable<Money> {
    return invoices$.pipe(
        map((invoices) =>
            invoices.reduce<Money>(
                (money, invoice) => {
                    const moneyValue = invoice[moneyKey] as Money;
                    if (moneyValue) {
                        let cents =
                            typeof money.cents === 'string'
                                ? parseInt(money.cents, 10)
                                : money.cents;

                        cents += parseInt((moneyValue.cents as unknown) as string, 10);

                        return {
                            ...money,
                            cents
                        };
                    } else {
                        return {
                            ...money,
                            cents: 0
                        };
                    }
                },
                { cents: 0, currencyCode: CurrencyCode.USD }
            )
        )
    );
}

export class LoadableInvoiceSummary extends InvoiceSummary2 {
    public isRowLoading: boolean;

    constructor(loadableInvoiceSummary?: Partial<LoadableInvoiceSummary>) {
        super(loadableInvoiceSummary);
        this.isRowLoading = loadableInvoiceSummary?.isRowLoading;
    }
}

export enum InvoicesFilterType {
    ShowAll = 1,
    OnlyAvailable = 2,
    OnlyPending = 3,
    OnlyPaid = 4,
    OnlyExpired = 5,
    OnlyClosed = 6,
    OnlyPaidOnTerms = 7,
    OnlyRevoked = 8,
    OnlyScheduled = 9
}
